import { Component, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Station } from '../entities/city';
import { FormControl } from '@angular/forms';
declare var _apiUrl: any;

@Component({
  selector: 'app-stations',
  templateUrl: './stations.component.html',
  styleUrls: ['./stations.component.css']
})
export class StationsComponent implements OnInit {

  public cities$: Observable<string[]>;
  public stations$: Observable<any>;
  public stations: Station[];
  allStations: Station[];
  myControl = new FormControl();
  filteredOptions: Observable<string[]>;
  public cities: string[] = [];
  selectCity;
  isLoading = true;

  constructor(private http: HttpClient) { }

  ngOnInit() {
    this.cities$ = this.http.get<string[]>(_apiUrl + '/Gov/GetCities');
    this.cities$.subscribe(cit => this.setCities(cit));

    this.http.get<Station[]>(_apiUrl + '/Gov/GetStations?cityName=null').subscribe(s => {
      this.isLoading = false;
      this.allStations = s;
      this.stations = s;

      if (this.detectMob()) {
        this.sortByPosition();
      };
    });
  }

  sortByPosition() {
    this.getPosition().then(pos => {
      for (var i = 0; i < this.stations.length; i++) {
        //31.801443, 35.21156
        this.stations[i]["Distance"] = this.calculateDistance(pos.lat, pos.lng, this.stations[i]["lat"], this.stations[i]["lng"], "N");
      }

      this.stations.sort(function (a, b) {
        return a.Distance - b.Distance;
      });
    });
  }


  private setCities(cit: string[]) {
    this.cities = cit;
  }


  stationClick(station) {
    station.show = !station.show;
  }

  objChanged(event) {
    this.stations = this.allStations.filter(s => s.CityName === this.selectCity
      || s.Name === this.selectCity);
  }

  searchCity(term: string, item: any) {
    return item.CityName.indexOf(term) === 0;
  }

  clearSelect() {
    this.stations = this.allStations;
  }

  getPosition(): Promise<any> {
    return new Promise((resolve, reject) => {

      navigator.geolocation.getCurrentPosition(resp => {

        resolve({ lng: resp.coords.longitude, lat: resp.coords.latitude });
      },
        err => {
          reject(err);
        });
    });

  }

  calculateDistance(lat1, lon1, lat2, lon2, unit) {
    var radlat1 = Math.PI * lat1 / 180
    var radlat2 = Math.PI * lat2 / 180
    var radlon1 = Math.PI * lon1 / 180
    var radlon2 = Math.PI * lon2 / 180
    var theta = lon1 - lon2
    var radtheta = Math.PI * theta / 180
    var dist = Math.sin(radlat1) * Math.sin(radlat2) + Math.cos(radlat1) * Math.cos(radlat2) * Math.cos(radtheta);
    dist = Math.acos(dist)
    dist = dist * 180 / Math.PI
    dist = dist * 60 * 1.1515
    if (unit == "K") { dist = dist * 1.609344 }
    if (unit == "N") { dist = dist * 0.8684 }
    return dist
  }

  detectMob() {
    return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);

    //return ((window.innerWidth <= 800) && (window.innerHeight <= 640));
  }
}
